import posthog from 'posthog-js';

/**
 * Initialize PostHog with configuration from environment variables
 * This should be called once at app startup
 * Returns the posthog client instance (initialized or not)
 */
export function initPostHog() {
  const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
  const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

  // Only initialize if we have a key
  if (posthogKey) {
    try {
      posthog.init(posthogKey, {
        api_host: posthogHost,
        person_profiles: 'identified_only', // Only create profiles for identified users
        capture_pageview: true,
        capture_pageleave: true,
      });
    } catch (error) {
      console.error('[PostHog] Failed to initialize:', error);
    }
  } else {
    // In development, we might not have PostHog configured
    // This is fine, PostHogProvider will handle it gracefully
    if (import.meta.env.DEV) {
      console.warn('[PostHog] VITE_POSTHOG_KEY not found, PostHog will not be initialized');
    }
  }

  return posthog;
}

